import { render, staticRenderFns } from "./PointsToCreditSummary.vue?vue&type=template&id=9f21e99c"
import script from "./PointsToCreditSummary.vue?vue&type=script&lang=js"
export * from "./PointsToCreditSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports